// see https://github.com/Luka967/websocket-close-codes#websocket-close-codes
export enum CloseCodes {
  NORMAL_CLOSURE = 1000,
  NO_STATUS_RECEIVED = 1005,
  ABNORMAL_CLOSURE = 1006,
  TIMEOUT = 3008,
  /* Reserved for Colyseus */
  CONSENTED = 4000,
  SERVER_SHUTDOWN = 4001,
  WITH_ERROR = 4002,
  FAILED_TO_RECONNECT = 4003,
  MAY_TRY_RECONNECT = 4010,
  /* Reserved for PAC */
  USER_INACTIVE = 4101,
  USER_KICKED = 4102,
  USER_BANNED = 4103,
  USER_NOT_AUTHENTICATED = 4104,
  USER_RANK_TOO_LOW = 4105,
  USER_RANK_TOO_HIGH = 4106,
  USER_TIMEOUT = 4107,
  USER_DELETED = 4108,
  USER_IN_ANOTHER_GAME = 4109,
  USER_ALREADY_JOINED = 4110,
  USER_NOT_WHITELISTED = 4111,
  ROOM_FULL = 4120,
  ROOM_EMPTY = 4121,
  ROOM_DELETED = 4122,
  INVALID_PASSWORD = 4123,
  GAME_ALREADY_STARTED = 4130
}

export const CloseCodesMessages: { [code in CloseCodes]?: string } = {
  [CloseCodes.SERVER_SHUTDOWN]: "SERVER_SHUTDOWN",
  [CloseCodes.FAILED_TO_RECONNECT]: "FAILED_TO_RECONNECT",
  [CloseCodes.USER_INACTIVE]: "USER_INACTIVE",
  [CloseCodes.USER_KICKED]: "USER_KICKED",
  [CloseCodes.USER_BANNED]: "USER_BANNED",
  [CloseCodes.USER_DELETED]: "USER_DELETED",
  [CloseCodes.USER_RANK_TOO_LOW]: "USER_RANK_TOO_LOW",
  [CloseCodes.USER_NOT_AUTHENTICATED]: "USER_NOT_AUTHENTICATED",
  [CloseCodes.USER_NOT_WHITELISTED]: "USER_NOT_WHITELISTED",
  [CloseCodes.USER_TIMEOUT]: "USER_TIMEOUT",
  [CloseCodes.ROOM_FULL]: "ROOM_FULL",
  [CloseCodes.ROOM_EMPTY]: "ROOM_EMPTY",
  [CloseCodes.ROOM_DELETED]: "ROOM_DELETED",
  [CloseCodes.USER_IN_ANOTHER_GAME]: "USER_IN_ANOTHER_GAME",
  [CloseCodes.USER_ALREADY_JOINED]: "USER_ALREADY_JOINED",
  [CloseCodes.GAME_ALREADY_STARTED]: "GAME_ALREADY_STARTED",
  [CloseCodes.INVALID_PASSWORD]: "INVALID_PASSWORD"
}
